import FieldEditor from "components/FieldEditor";
import { Account, FieldError, IdName, Withdrawal } from "types";
import * as fields from "pages/transactions/withdrawalFieldDefinitions";
import { useEffect, useState } from "react";
import { requiredDateField, requiredTextField } from "common/functions";
import TransactionEditorTemplate from "pages/accountHistory/components/TransactionEditorTemplate";
import PickListNonFieldEditor from "components/fields/PickListNonFieldEditor";

export type Props = {
  transaction: Withdrawal;
  account: Account | undefined;
  onCancel(): void;
  onSave(transaction: Withdrawal, recurringMonths?: number): void;
};

export default function WithdrawalForm({
  transaction,
  account,
  onCancel,
  onSave,
}: Props) {
  const [state, setState] = useState<Withdrawal>(transaction);
  const [errors, setErrors] = useState<FieldError[]>([]);
  const [
    selectedRecuringMonths,
    setSelectedRecuringMonths,
  ] = useState<string>();
  const recurringOptions: IdName[] = [
    { id: "2", name: "2" },
    { id: "3", name: "3" },
    { id: "4", name: "4" },
    { id: "5", name: "5" },
    { id: "6", name: "6" },
    { id: "7", name: "7" },
    { id: "8", name: "8" },
    { id: "9", name: "9" },
    { id: "10", name: "10" },
    { id: "11", name: "11" },
    { id: "12", name: "12" },
    { id: "24", name: "24" },
    { id: "36", name: "36" },
  ];

  useEffect(() => {
    errors.length > 0 && checkErrors();
  }, [state]);

  const commonProps = {
    state: state,
    errors,
    setState: (state: Withdrawal) => {
      setState(state);
    },
  };

  function checkErrors() {
    if (!transaction) {
      return;
    }
    const errorsArray: FieldError[] = [
      ...requiredDateField(fields.withdrawalTransactionDateTime, state),
      ...requiredTextField(fields.withdrawalAmount, state),
    ];
    setErrors(errorsArray);
    return errorsArray;
  }

  return (
    <TransactionEditorTemplate
      id={`Withdrawal_${transaction.transactionId}_form`}
      onSaveClick={() => {
        const err = checkErrors();
        if (err?.length === 0) {
          onSave(
            state,
            selectedRecuringMonths
              ? parseInt(selectedRecuringMonths)
              : undefined
          );
        }
      }}
      onCancelClick={onCancel}
      type={
        transaction.transactionType === "TRANSFER"
          ? "Transfer"
          : transaction.transactionType === "GL_ENTRY"
          ? "GL Entry"
          : "Withdrawal"
      }
      column1Fields={
        <>
          <FieldEditor<Withdrawal>
            field={fields.withdrawalTransactionDateTime}
            {...commonProps}
          />
          <FieldEditor<Withdrawal>
            field={fields.withdrawalDescription}
            {...commonProps}
          />
        </>
      }
      column2Fields={
        <>
          <FieldEditor<Withdrawal>
            field={fields.withdrawalAmount}
            {...commonProps}
          />
          {!transaction.transactionDateTime && (
            <PickListNonFieldEditor
              id="withdrawlReccuring"
              label="Recurring For Months"
              value={selectedRecuringMonths || ""}
              options={recurringOptions}
              onChange={(value) => {
                setSelectedRecuringMonths(value);
              }}
            />
          )}
        </>
      }
    />
  );
}
